import React from "react";
import AppContainer from "./appcontainerV2.jsx";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { ToastContainer } from "mdbreact";
import { CartProvider } from "./CartContext.js";
import { WhatsAppButton } from "./components/ButtonWhatsApp/index.js"
import { } from "react-router-dom";

const AppRouter = function (props) {
  return (
    <CartProvider>
      <Router>
        <Route render={(props) => <AppContainer {...props} />} />
      </Router>
      <ToastContainer
        className={"custonNotif"}
        closeButton={false}
        autoClose={3000}
        hideProgressBar={true}
      />

      < WhatsAppButton
        number={"59176759954"}
        message={"¡Hola, Casaideas! Necesito ayuda con mi compra online. ¿Me podrían asesorar?"}
        isView={false}
      />
    </CartProvider>
  );
};

export default AppRouter;
